import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,        // 5 minutes
      gcTime: 1000 * 60 * 30,           // 30 minutes
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          // Don't retry on client errors (4xx) except 429
          if (error.status >= 400 && error.status < 500 && error.status !== 429) {
            return false
          }
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
})
